import { matchPath } from 'react-router-dom'
import { ROUTES } from '@shared/constants/routes'
import { hasProfileInfoSectionSearch } from '@shared/constants/profile'

export type FooterIconKey = 'home' | 'timer' | 'workouts'

export interface FooterIconProperty {
	icon: FooterIconKey
	titleKey: string
	path: string
	matchPaths: string[]
}

const routesWithFooterWithoutActiveTab = [
	ROUTES.overall.profile,
	ROUTES.overall.aiMessenger,
	ROUTES.overall.checkTechnique,
]

export const footerIcons: FooterIconProperty[] = [
	{
		titleKey: 'navigation.home',
		icon: 'home',
		path: ROUTES.overall.main,
		matchPaths: [ROUTES.overall.main],
	},
	{
		titleKey: 'navigation.timer',
		icon: 'timer',
		path: ROUTES.overall.timer,
		matchPaths: [ROUTES.overall.timer, ROUTES.overall.timerDetail],
	},
	{
		titleKey: 'navigation.workouts',
		icon: 'workouts',
		path: ROUTES.overall.trainingConstructor,
		matchPaths: [ROUTES.overall.trainingConstructor],
	},
]

export function getFooterActiveIndex(pathname: string): number {
	return footerIcons.findIndex((item) =>
		item.matchPaths.some((path) => matchesRoute(pathname, path))
	)
}

export function shouldShowFooterForRoute(pathname: string, search: string): boolean {
	const isProfileSubpage =
		pathname === ROUTES.overall.profile && hasProfileInfoSectionSearch(search)
	const isTrainingDetailsOverlay =
		pathname === ROUTES.overall.trainingConstructor &&
		Boolean(new URLSearchParams(search).get('training'))

	return (
		!isProfileSubpage &&
		!isTrainingDetailsOverlay &&
		(getFooterActiveIndex(pathname) >= 0 ||
			routesWithFooterWithoutActiveTab.some((path) => matchesRoute(pathname, path)))
	)
}

function matchesRoute(pathname: string, path: string): boolean {
	return Boolean(
		matchPath(pathname, {
			path,
			exact: true,
		})
	)
}
